import { defineMessages } from 'react-intl';

export const shipmentDropdownMessages = defineMessages({
  shipmentDropdownLabel: {
    description: 'Label for a dropdown menu item for selecting a shipment',
    defaultMessage:
      'Shipment {shipmentCounter}{subtext, select, createsNew {<span> (creates new)</span>} new {<span> (new)</span>} other {}}',
    id: '6k6Voo',
  },
});

export const itemRowContentMessages = defineMessages({
  sku: {
    description: 'SKU (Stock Keeping Unit) label, followed by the actual SKU',
    defaultMessage: 'SKU: {sku}',
    id: '3BBWq3',
  },
});
